export const DARK_BACKGROUND = '#000C';
export const STANDARD_BACKGROUND = '#0009';
export const DEFAULT_CLOSE_BEHAVIOR = true;
export const DEFAULT_STYLES = {
  overlay: {
    textAlign: 'center',
    overflowY: 'scroll'
  },
  content: {
    top: null,
    left: null,
    right: null,
    bottom: null,
    border: null,
    background: null,
    borderRadius: null,
    display: 'inline-block',
    padding: null,
    position: null,
    outline: 'none',
    overflow: null,
    marginTop: '15%'
  }
};
export const NAVIGATION_STYLES = {
  overlay: {
    textAlign: 'right'
  },
  content: {
    ...DEFAULT_STYLES.content,
    top: 0,
    right: 0,
    bottom: 0,
    position: 'absolute',
    marginTop: 0,
    width: '100%'
  }
};

export const DEMO_STEPS_MODAL = {
  content: {
    ...DEFAULT_STYLES.content,
    backgroundColor: '#FFFFFF',
    borderTop: '5px solid #E31837',
    height: '90%',
    left: '50%',
    marginTop: null,
    padding: '24px 0 24px 24px',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%'
  }
}

export const ADVERTISING_PRACTICES = {
  content: {
    ...DEFAULT_STYLES.content,
    backgroundColor: '#FFFFFF',
    height: '80%',
    left: '50%',
    marginTop: null,
    padding: '24px 0 24px 24px',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '350px'
  }
}

export const EXIT_MODAL = {
  content: {
    ...DEFAULT_STYLES.content,
    backgroundColor: '#FFFFFF',
    left: '50%',
    marginTop: null,
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%'
  }
}